<h4>Financial Transactions</h4>
<form #f="ngForm" (ngSubmit)="f.form.valid && onSubmit(f)">
    <div class="row form-group">
        <div class="col-md-4">Record creation date</div>
        <div class="col-md-6">
            <input type="text" name="creation_date" placeholder="Record creation date"
                class="form-control form-control-sm" [value]="quote.quote_versions[0].create_date | date:'dd-MM-yyyy'"
                readonly>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Quote start date</div>
        <div class="col-md-6">
            <input type="text" name="creation_date" placeholder="Quote creation date"
                class="form-control form-control-sm"
                [value]="quote.quote_versions[0].policy_start_date | date:'dd-MM-yyyy'" readonly>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-md-4">Quote end date</div>
        <div class="col-md-6">
            <input type="text" name="creation_date" placeholder="Quote end date" class="form-control form-control-sm"
                [value]="quote.quote_versions[0].policy_end_date | date:'dd-MM-yyyy'" readonly>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-md-4">Quote Type</div>
        <div class="col-md-6">
            <mat-form-field class="w-100 float-left customDropdown">
                <mat-select [(ngModel)]="quote.quote_versions[0].type" disabled class="form-control form-control-sm"
                    name="quote_type">
                    <mat-option [value]="1">New Business</mat-option>
                    <mat-option [value]="2">Renewal</mat-option>
                    <mat-option [value]="3">MTA</mat-option>
                    <mat-option [value]="4">Cancelled</mat-option>
                    <mat-option [value]="5">Lapsed</mat-option>
                    <mat-option [value]="6">NTU</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Net Premium </div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="net_premium" placeholder="Gross Premium" class="form-control form-control-sm"
                    [value]="this.quote.quote_versions[0].financial_details.policy_premium * (100-((this.quote.quote_versions[0].financial_details.broker_commission-0) + (this.quote.quote_versions[0].financial_details.peliwica_pay_away_commission-0) + (this.quote.quote_versions[0].financial_details.peliwica_retained_commission-0)))/100| number:'1.2-2'"
                    readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Broker Commission</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">%</span>
                </div>
                <input type="text" name="broker_commission" placeholder="Broker Commission"
                    class="form-control form-control-sm"
                    [value]="quote.quote_versions[0].financial_details.broker_commission" readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Broker Gross Commission</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="broker_gross_commision" placeholder="Gross Commission"
                    class="form-control form-control-sm"
                    [value]="(quote.quote_versions[0].financial_details.policy_premium * quote.quote_versions[0].financial_details.broker_commission)/100 | number:'1.2-2'"
                    readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Peliwica pay away commission</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">%</span>
                </div>
                <input type="text" name="peliwica_pay_away_commission" placeholder="Peliwica Pay Away Commission"
                    class="form-control form-control-sm"
                    [value]="quote.quote_versions[0].financial_details.peliwica_pay_away_commission" readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Peliwica pay away gross commission</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="payaway_gross_commision" placeholder="Gross Commission"
                    class="form-control form-control-sm"
                    [value]="(quote.quote_versions[0].financial_details.policy_premium * quote.quote_versions[0].financial_details.peliwica_pay_away_commission)/100 | number:'1.2-2'"
                    readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Peliwica retained commission</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">%</span>
                </div>
                <input type="text" name="peliwica_retained_commission" placeholder="Peliwica Retained Commission"
                    class="form-control form-control-sm"
                    [value]="quote.quote_versions[0].financial_details.peliwica_retained_commission" readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Peliwica retained gross commission</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="retained_gross_commision" placeholder="Gross Commission"
                    class="form-control form-control-sm"
                    [value]="(quote.quote_versions[0].financial_details.policy_premium * quote.quote_versions[0].financial_details.peliwica_retained_commission)/100 | number:'1.2-2'"
                    readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Premium Loading</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="premium_loading" placeholder="Premium Loading"
                    class="form-control form-control-sm"
                    [value]="quote.quote_versions[0].financial_details.premium_loading" readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Total Premium (Excl IPT)</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="retained_gross_commision" placeholder="Total Premium"
                    class="form-control form-control-sm"
                    [value]="quote.quote_versions[0].financial_details.policy_premium"
                    readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Insurance Premium Tax % (IPT)</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">%</span>
                </div>
                <input type="text" name="retained_gross_commision" placeholder="IPT"
                    class="form-control form-control-sm" [value]="quote.quote_versions[0].financial_details.ipt_fee"
                    readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Insurance Premium Tax &pound; (IPT)</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="retained_gross_commision" placeholder="IPT"
                    class="form-control form-control-sm"
                    [value]="(quote.quote_versions[0].financial_details.policy_premium * quote.quote_versions[0].financial_details.ipt_fee)/100 | number:'1.2-2'" readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Total Premium (Incl IPT)</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="total_premium_ipt" placeholder="Total Premium (Incl IPT)"
                    class="form-control form-control-sm"
                    [value]="quote.quote_versions[0].financial_details.total_premium" readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Underwriting Fee</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="uw_fee" placeholder="Underwriting Fee" class="form-control form-control-sm"
                    [value]="quote.quote_versions[0].financial_details.uw_fee | number: '1.2-2'" readonly>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-md-4">Total Amount To Pay</div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                </div>
                <input type="text" name="total_amount_to_pay" placeholder="Total Amount To Pay"
                    class="form-control form-control-sm"
                    [value]="((quote.quote_versions[0].financial_details.total_premium-0) + (quote.quote_versions[0].financial_details.uw_fee-0) | number: '1.2-2')"
                    readonly>
            </div>

        </div>
    </div>
    <!-- <div class="form-group">
        <input type="submit" name="submit" class="btn btn-success btn-gray" value="Save">
    </div> -->
</form>